module.exports = __webpack_public_path__ + "img/filetype_video.7f4be7bc.png";